import React from 'react';

/* tslint:disable */
const SvgIconSms = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 72 72' {...props}>
    <path d='M63 0H9a9 9 0 0 0-9 9v40.5a9 9 0 0 0 9 9h13.5v11.81A1.69 1.69 0 0 0 24.19 72a1.63 1.63 0 0 0 1-.34L42.75 58.5H63a9 9 0 0 0 9-9V9a9 9 0 0 0-9-9zm2.25 49.5A2.25 2.25 0 0 1 63 51.75H40.5l-1.8 1.35-9.45 7.09v-8.44H9a2.25 2.25 0 0 1-2.25-2.25V9A2.25 2.25 0 0 1 9 6.75h54A2.25 2.25 0 0 1 65.25 9z' />
  </svg>
);
/* tslint:enable */

export default SvgIconSms;

